import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';

const PlaqueList = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [PlaqueList, setPlaqueList] = useState([]);
  const tableRef = useRef(null);
  const completedTableRef = useRef(null);                                         // added
  const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
  const [chapterId, setChapterId] = useState(initialChapter);

  const fetchPlaqueList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      let url = `${baseurl}/admin/PlaqueList`;
      if (roleid !== 1) {
        url += `?chapter_id=${chapterId}`;
      }
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setPlaqueList(data);
    } catch (error) {
      console.error('Error fetching PlaqueList:', error);
    }
  };

  useEffect(() => {
    fetchPlaqueList();
  }, []);

  // Same getColumns pattern as CardList
  const getColumns = (isCompleted) => ({
    columns: [
      { data: null, title: 'Sr.No', className: "text-center" },
      {
        data: 'membership_no', title: 'Membership No', className: "text-center",
        render: (data, type, row) =>
          type !== 'display'
            ? (data ?? '')
            : `<a href="/admin/EditMember?memberId=${row.member_id}&edit=false" onclick="event.preventDefault(); window.open(this.href, '_blank');">${data ?? ''}</a>`,
      },
      { data: 'chapter_id', title: 'Chapter ID', className: "text-center" },
      { data: null, title: 'Name', className: "text-center" },
      { data: null, title: 'Photo', className: "text-center", orderable: false },
      { data: 'mobile_no', title: 'Mobile No', className: "text-center" },
      { data: 'email', title: 'Email', className: "text-center" },
      { data: null, title: 'Address', className: "text-center" },
      { data: 'payment_no', title: 'Transaction No', className: "text-center" },
      { data: 'request_date', title: 'Request Date', className: "text-center" },
      // { data: 'expiry_date', title: 'Valid Till', className: "text-center" },
      { data: null, title: 'Action', orderable: false, className: "text-center" },
    ],
    columnDefs: [
      {
        targets: 0,
        render: (data, type, row, meta) => meta.row + 1,
      },
      {
        targets: 3,
        render: row => `${row.first_name || ''} ${row.last_name || ''}`
      },
      {
        // Photo column — same as CardList
        targets: 4,
        render: (data, type, row) => {
          if (row.photo_url) {
            return `<img
              src="${row.photo_url}"
              alt="Photo"
              style="width:45px;height:45px;border-radius:50%;object-fit:cover;border:2px solid #dee2e6;cursor:pointer;"
              class="member-photo"
              data-img="${row.photo_url}"
            />`;
          }
          const initials = `${(row.first_name || '')[0] || ''}${(row.last_name || '')[0] || ''}`.toUpperCase();
          return `<div style="
            width:45px;height:45px;border-radius:50%;
            background:#6c757d;color:white;
            display:flex;align-items:center;justify-content:center;
            font-weight:bold;font-size:14px;margin:auto;
            border:2px solid #dee2e6;
          ">${initials || '?'}</div>`;
        },
      },
      
      {
        targets: 7,
        render: (data, type, row) => {
          const address = [row.present_address, row.present_city, row.present_state, row.present_pincode]
            .filter(val => val && val !== '')
            .join(', ');
          return address || '-';
        }
      },
      {
        targets: 9,
        render: (data) => {
          if (!data) return "-";
              // If already in DD/MM/YYYY
          if (data.includes("/")) {
            return data.replace(/\//g, "-");
          }
          // If ISO or other format → convert to IST
          return new Date(data).toLocaleDateString("en-GB", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }).replace(/\//g, "-");
        },
      },
      {
        targets: 10,
        render: (data, type, row) => {
          // if (isCompleted) {
          //   // Completed table — badge only, same as CardList
          //   const badgeColor = row.cstatus === 'delivered' ? 'success' : 'danger';
          //   return `<span class="badge bg-${badgeColor} text-capitalize">${row.cstatus}</span>`;
          // }

          if (roleid === 1) {
            return `
              <select class="form-select form-select-sm status-dropdown" data-id="${row.plaque_id}" style="width:130px;margin:auto;">
                <option value="">-- Change Status --</option>
                <option value="approved" ${row.cstatus === 'approved' ? 'selected' : ''}>Approved</option>
                <option value="rejected" ${row.cstatus === 'rejected' ? 'selected' : ''}>Rejected</option>
                <option value="delivered" ${row.cstatus === 'delivered' ? 'selected' : ''}>Delivered</option>
              </select>
            `;
          } else {
            return `<span class="badge bg-secondary text-capitalize">${row.cstatus}</span>`;
          }
        },
      },
    ],
  });

  // Same initTable helper as CardList
  const initTable = (tableElement, data, isCompleted) => {
    if (!tableElement) return;

    if ($.fn.DataTable.isDataTable(tableElement)) {
      $(tableElement).DataTable().destroy();
    }

    const { columns, columnDefs } = getColumns(isCompleted);

    $(tableElement).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
      buttons: [
        { extend: 'copyHtml5',  className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(:nth-child(2))' } },
        { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(:nth-child(2))' } },
        { extend: 'csvHtml5',   className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(:nth-child(2))' } },
        { extend: 'pdfHtml5',   className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(:nth-child(2))' } },
        { extend: 'print',      className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(:nth-child(2))' } },
      ],
      data,
      columns,
      columnDefs,
      destroy: true,
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');
      }
    });
  };

  useEffect(() => {
    if (!PlaqueList.length) return;

    // Split into Requested vs Completed — same logic as CardList
    const requestedData = PlaqueList.filter(
      item => !['rejected', 'delivered'].includes(item.cstatus)
    );
    const completedData = PlaqueList.filter(
      item => ['rejected', 'delivered'].includes(item.cstatus)
    );

    initTable(tableRef.current, requestedData, false);
    initTable(completedTableRef.current, completedData, true);

    // Photo preview on click
    $(document).off('click', '.member-photo').on('click', '.member-photo', function () {
      const imgSrc = $(this).data('img');
      Swal.fire({
        imageUrl: imgSrc,
        imageAlt: 'Member Photo',
        showConfirmButton: false,
        showCloseButton: true,
        width: 400,
      });
    });

    // Status dropdown — same as CardList
    $(document).off('change', '.status-dropdown').on('change', '.status-dropdown', async function () {
      const id = $(this).data('id');
      const status = $(this).val();
      if (!status) return;

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `Change plaque status to "${status}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Yes, ${status}!`,
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        try {
          const token = sessionStorage.getItem("token");
          await $.ajax({
            url: `${baseurl}/admin/PlaqueList/${id}`,
            type: 'PUT',
            headers: { Authorization: `${token}`, 'Content-Type': 'application/json' },
            data: JSON.stringify({ status }),
          });
          Swal.fire('Updated!', `Status changed to ${status}.`, 'success');
          fetchPlaqueList();
        } catch (error) {
          console.error('Error updating status:', error);
          Swal.fire('Error', 'Error while updating status.', 'error');
        }
      } else {
        $(this).val('');
      }
    });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      if ($.fn.DataTable.isDataTable(completedTableRef.current)) {
        $(completedTableRef.current).DataTable().destroy();
      }
    };
  }, [PlaqueList]);

  return (
    <div className="content container-fluid">

      {/* ── Requested Plaque List ── */}
      <center><h3 className="mt-3">Requested Plaque List</h3></center>
      <div className="container mt-2">
        <div className="profile-section">
          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <div className="col-12">
                <table
                  ref={tableRef}
                  className="table table-striped table-bordered"
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Completed Plaque List ── */}
      <center>
        <h3 className="mt-5" style={{ color: '#495057' }}>
          Completed Plaque List
          <span className="ms-2 badge bg-secondary" style={{ fontSize: '0.6em', verticalAlign: 'middle' }}>
            Rejected &amp; Delivered
          </span>
        </h3>
      </center>
      <div className="container mt-2 mb-5">
        <div className="profile-section">
          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <div className="col-12">
                <table
                  ref={completedTableRef}
                  className="table table-striped table-bordered"
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default PlaqueList;